import {AxiosPromise, AxiosRequestConfig} from 'axios';
import buildURL from 'axios/lib/helpers/buildURL';

import api, {PROXY_BASE_URL} from 'services/api/api';

export const MERCURY_LB = 'lb://prodmercury';
export const MERCURY_BASE_URL = `${PROXY_BASE_URL}?${MERCURY_LB}/mercury`;

const runMercuryAPIRequest = (config: AxiosRequestConfig): AxiosPromise => {
  /**
   * Build URL params directly into the url using the axios buildURL helper.
   *
   * This is required because there is a bug (for us?),
   * where it will include the basURL in it's search for '?',
   * and will encode append the param list using '&',
   *
   * See https://github.com/axios/axios/blob/76f09afc03fbcf392d31ce88448246bcd4f91f8c/lib/adapters/xhr.js#L43-L44
   * and https://github.com/axios/axios/blob/76f09afc03fbcf392d31ce88448246bcd4f91f8c/lib/helpers/buildURL.js#L66
   *
   * This is almost the equivalent as writing the url manually using string interp,
   * but allows us to correctly URL encode certain characters and date strings.
   */
  if (config.params) {
    config.url = config.url + buildURL(config.url, config.params);
    delete config.params;
  }

  // add the base URL to the request
  config.baseURL = `${api.defaults.baseURL}${MERCURY_BASE_URL}`;
  return api.request(config);
};

//
// --- Export Endpoints ---

/**
 * Return all Mercury API calls namespaced to a MercuryAPI namespace object
 */
const MercuryAPI = {
  runMercuryAPIRequest,
};

export default MercuryAPI;
